<div class="forgot-password-body">
  <main class="main">
    <div class="ui-g">
      <div class="ui-g-12 flex-center-center">
        <div class="ui-g-4 flex-center-center">
          <div class="card p-4">
            <div class="card-body">
              <form>
                <div class="row justify-content-center mb-3">
                  <div class="col-md-7 logo">
                    <img src="../../../../assets/alp_logo_transparent.png" class="img-fluid" alt="">
                    <p class="welcome">Forgot Password</p>
                  </div>
                </div>
                <div class="form-group">
                  <app-input placeholder="Username" [errorMessage]="validate.email" [isInvalid]="validate.email"
                    [value]="user.password" [floatingLabel]="true" (appChange)="onChange('email', $event)"
                    (appFocus)="onFocus('email')"></app-input>
                </div>

                <div class="row">
                  <div class="col-sm-12 text-center mt-10 mb-10">
                    <button type="submit" (click)="onSubmit()" class="btn btn-block btn-primary btn-submit" [disabled]="disabled">
                      Reset Password
                      <i *ngIf="disabled" class="fal fa-spinner rotate ml-1"></i>
                    </button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 text-center">
                    <p class="pointer font-primary hover-underline" (click)="resetPassword()">
                      Back to sign in
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
<ngx-loading-bar></ngx-loading-bar>
